import React, { useEffect, useState } from "react";
import { useT } from "../i18n/LanguageContext";
import { Link } from "react-router-dom";

const STORAGE_KEY = "bigradap.cookie.ack";

export default function CookieBanner() {
  const { t } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.localStorage.getItem(STORAGE_KEY)) {
      const tmo = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(tmo);
    }
  }, []);

  if (!show) return null;
  return (
    <div
      className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl border border-white/15 bg-black/90 px-5 py-4 text-sm text-white shadow-2xl backdrop-blur-xl sm:bottom-6"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-white/85">{t("cookie.text")}</p>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            to="/legal"
            className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand-textDim hover:text-white"
            data-testid="cookie-learn"
          >
            {t("cookie.learn")}
          </Link>
          <button
            type="button"
            onClick={() => {
              window.localStorage.setItem(STORAGE_KEY, "1");
              setShow(false);
            }}
            data-testid="cookie-accept"
            className="bg-brand-red px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-white hover:bg-brand-redHover"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
